@if (student$ | async; as student) {
  <main
    [ngClass]="{
      'student-bursaries-info-container row2': isStudent,
      'student-info-more row2': !isStudent
    }"
  >
    <article>
      <ng-container>
        <h2 [ngClass]="{ 'student-bursary': isStudent, bursary: !isStudent }">
          Bursary Information
        </h2>
        <mat-divider class="divider"></mat-divider>
        <ng-template #yearOfFunding>
          <section class="student-info-item">
            <p [ngClass]="getGreyTextClass()">Year of funding</p>
            <p [ngClass]="getBlackTextClass()">{{ student.yearOfFunding }}</p>
          </section>
        </ng-template>
        <ng-template #applicationDate>
          <section class="student-info-item">
            <p [ngClass]="getGreyTextClass()">Application Date</p>
            <p [ngClass]="getBlackTextClass()">{{ student.applicationDate }}</p>
          </section>
        </ng-template>
        <section
          class="student-bursaries-info row2"
          [ngClass]="{
            'single-row-bursary-info': isStudent && !student.commencementDate
          }"
        >
          <section class="amount">
            <p [ngClass]="getGreyTextClass()">Bursary Amount</p>
            <p [ngClass]="getBlackTextClass()">
              {{ student.amount | customCurrency }}
            </p>
          </section>
          <section class="status">
            <p [ngClass]="getGreyTextClass()">Status</p>
            <p [ngClass]="getBlackTextClass()">
              {{
                student.status == "Approved"
                  ? (invoiceStatus$ | async)
                  : student.status
              }}
            </p>
          </section>
          @if (isStudent && !student.commencementDate) {
            <ng-container *ngTemplateOutlet="yearOfFunding"></ng-container>
          }
        </section>
        @if (!isStudent || student.commencementDate) {
          <mat-grid-list
            rowHeight="4rem"
            class="custom-grid"
            [gridCols]="{ xs: 1, sm: 2, md: 4, lg: 6, xl: 8 }"
            [ngClass]="{
              'student-bursaries-info row2': isStudent,
              'student-info-more row2': !isStudent
            }"
          >
            <mat-grid-tile>
              <ng-container *ngTemplateOutlet="yearOfFunding"></ng-container>
            </mat-grid-tile>
            <mat-grid-tile>
              <ng-container *ngTemplateOutlet="applicationDate"></ng-container>
            </mat-grid-tile>
            @if (!isStudent) {
              <mat-grid-tile>
                <section class="student-info-item">
                  <p [ngClass]="getGreyTextClass()">Approved Date</p>
                  <p [ngClass]="getBlackTextClass()">
                    {{ student.approvedDate }}
                  </p>
                </section>
              </mat-grid-tile>
            }
            <mat-grid-tile>
              @if (student.commencementDate) {
                <section class="student-info-item">
                  <p [ngClass]="getGreyTextClass()">Date of Commencement</p>
                  <p [ngClass]="getBlackTextClass()">
                    {{ student.commencementDate }}
                  </p>
                </section>
              }
            </mat-grid-tile>
          </mat-grid-list>
        }
      </ng-container>
      @if (shouldShowFundDistribution(student)) {
        <section>
          <h2
            [ngClass]="{
              'student-Fund-distribution': isStudent,
              'Fund-distribution': !isStudent
            }"
          >
            Fund distribution
          </h2>
          <mat-divider class="divider"></mat-divider>
          <section class="student-bursaries-info row2">
            <section class="student-info-item">
              <p [ngClass]="getGreyTextClass()">Tuition</p>
              <p [ngClass]="getBlackTextClass()">
                {{ student.tuition | customCurrency }}
              </p>
            </section>
            <section class="student-info-item">
              <p [ngClass]="getGreyTextClass()">Accommodation</p>
              <p [ngClass]="getBlackTextClass()">
                {{ student.accommodation | customCurrency }}
              </p>
            </section>
            <section class="student-info-item">
              <p [ngClass]="getGreyTextClass()">Meals</p>
              <p [ngClass]="getBlackTextClass()">
                {{ student.meals | customCurrency }}
              </p>
            </section>
            <section class="student-info-item">
              <p [ngClass]="getGreyTextClass()">Other</p>
              @if (student.otherDescription) {
                <p [ngClass]="getBlackTextClass()">
                  {{ student.other | customCurrency }} ({{
                    student.otherDescription
                  }})
                </p>
              } @else {
                <p [ngClass]="getBlackTextClass()">
                  {{ student.other | customCurrency }}
                </p>
              }
            </section>
          </section>
        </section>
      }
      <section class="terms-container">
        <p class="termsAndConditionsConfirmation">
          Please note that all necessary terms and conditions still apply
          <a class="TsCs" [href]="urls.TERMS" target="_blank"
            >Terms and Conditions</a
          >
        </p>
      </section>
    </article>
  </main>
}
